import React, { useContext, useEffect } from 'react'
import { Form, InputNumber } from 'antd'
import styled from 'styled-components'
import { EditProductQuestionItemProps } from '../../types'
import {
  computedFillInBlankSumScore,
  editSubQuestion,
  getSubQuestions,
} from '../../utils'
import { QuestionTypeEnum } from 'packages/sdks-next/growp'
import { precisionFormat } from 'packages/utils'
import { EditPaperContext } from '@/features/test-paper/pages/EditPaper/context'

export const EditSubScore: React.FC<EditProductQuestionItemProps> = ({
  curQuestion,
  subQuestions,
  setSubQuestions,
  treeNodeId,
}) => {
  const { limitLevel } = useContext(EditPaperContext)
  const scoreTotal =
    curQuestion.type === QuestionTypeEnum.FillInBlank
      ? computedFillInBlankSumScore(
          getSubQuestions(subQuestions, curQuestion.id || treeNodeId || 0)
        )
      : curQuestion.score
  const onChangeScore = (newScore?: string | number | null) => {
    const newSubQuestions = editSubQuestion(subQuestions, treeNodeId || 0, {
      score: newScore ? String(newScore) : undefined,
    })
    setSubQuestions(newSubQuestions)
  }
  useEffect(() => {
    onChangeScore(scoreTotal)
  }, [scoreTotal])
  return (
    <StyleNumberFormItem
      label="分数"
      required
      rules={[{ required: true, message: '请输入分数' }]}
    >
      <InputNumber
        style={{ width: 160 }}
        placeholder={'请输入'}
        stringMode={true}
        disabled={
          limitLevel > 1 ||
          [QuestionTypeEnum.FillInBlank].includes(curQuestion.type)
        }
        value={precisionFormat(scoreTotal)}
        onChange={(v) => {
          onChangeScore(v)
        }}
      />
    </StyleNumberFormItem>
  )
}

const StyleNumberFormItem = styled(Form.Item)`
  &&& {
    margin-bottom: 0;
    .ant-input-number-group > .ant-input-number:first-child,
    .ant-input-number-group-addon:first-child {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
  }
`
